export default {
      id: "group-1-usage",
      viewBox: "0 0 26 27",
      url: __webpack_public_path__ + "sprite.svg#group-1",
      toString: function () {
        return this.url;
      }
    }